import { render, staticRenderFns } from "./ChangeStudent.vue?vue&type=template&id=f8bdee86&scoped=true&"
import script from "./ChangeStudent.vue?vue&type=script&lang=js&"
export * from "./ChangeStudent.vue?vue&type=script&lang=js&"
import style0 from "./ChangeStudent.vue?vue&type=style&index=0&id=f8bdee86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bdee86",
  null
  
)

export default component.exports